<template>
  <div class="index">
    <Row >
      <Col>
        <Card>
          <Row>
            <Col >
              <p class="subText">运营管理平台</p>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>

  </div>
</template>
<script>
  export default {
    name: 'index',
    data () {
      return {

      }
    },
    computed: {},
    methods: {
      /**
       * 刷新页面请求
       * */
      refresh () {

      }
    },
    created () {

    }
  }
</script>
<style lang="less" scoped>
  .subText {
    color: #657180;
    font-size: 30px;
    height: 250px;
    text-align: center;
    margin-top: 150px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Index.vue